export default __webpack_public_path__ + "static/media/play.e3515179.svg";